import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import MyOutOrdersTable from "../../components/MyOutOrdersTable";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Заказы",
    link: "/work/app/manage/orders"
  },
  {
    label: "Заказы организаций",
    link: "/work/app/manage/orders/orgorders"
  },
  {
    label: "Мои исходящие заказы",
    link: "#"
  }
];

const MyOutOrderList = () => {
  return (
    <div>
      <Breadcrumbs items={items} />
      <MyOutOrdersTable/>
    </div>
  );
};

export default MyOutOrderList;
